import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { Chart, DoughnutController, ArcElement, Tooltip, Legend } from 'chart.js';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

// Register Chart.js components needed for the doughnut chart on the dashboard.
Chart.register(DoughnutController, ArcElement, Tooltip, Legend);

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
